import { Moment } from 'moment';
import { CategoryNaturalKey } from './category';

export const enum DownloadLinkType {
    ByFile = 0,
    ByDate = 1,
    ByDocument = 3
}

interface DownloadLink {
    linkType: DownloadLinkType;
    categoryNaturalKey: CategoryNaturalKey;
}

export class LinkByFile implements DownloadLink {
    public readonly linkType = DownloadLinkType.ByFile;
    constructor(
        public readonly fileId: string,
        public readonly reportId: string,
        public readonly categoryNaturalKey: CategoryNaturalKey,
    ) {}

    public toQueryParamsObject(): { [key in keyof LinkByFile]?: string } {
        return {
            fileId: this.fileId,
            reportId: this.reportId,
            categoryNaturalKey: this.categoryNaturalKey,
        };
    }
}

export class LinkByDate implements DownloadLink {
    public readonly linkType = DownloadLinkType.ByDate;
    constructor (
        public readonly categoryNaturalKey: CategoryNaturalKey,
        public readonly date: Moment,
    ) {}
}

export class LinkByDocument implements DownloadLink {
    public readonly linkType = DownloadLinkType.ByDocument;
    constructor(
        public readonly categoryNaturalKey: CategoryNaturalKey,
        public readonly documentId: string,
    ) {}
}

export type DlLink =
    | LinkByFile
    | LinkByDate
    | LinkByDocument
    ;